import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { bulkUpdateMeetingNotesTemplate } from "../api/users";

export const useBulkUpdateMeetingNotesTemplate = (onSuccess) => {
  const queryClient = useQueryClient();

  const bulkUpdateMeetingNotesTemplateMutation = useMutation({
    mutationFn: ({ userSqids, templateId }) => {
      return bulkUpdateMeetingNotesTemplate(userSqids, templateId);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      queryClient.invalidateQueries({ queryKey: ["team-members-search"] });
      toast.success(
        `Notes template updated for ${variables.userSqids.length} user${
          variables.userSqids.length === 1 ? "" : "s"
        }`,
      );
      onSuccess?.();
    },
    onError: () => {
      toast.error(
        "There was a problem updating the notes template. Please try again.",
      );
    },
  });

  return { bulkUpdateMeetingNotesTemplateMutation };
};
